export const css = {
	root: '_2NwxsYZP',
	active: 'bPgNGAZY',
	selected: '_1gfGjRvB',
	disabled: '_209BQuj9',
	movedUp: 'Z1tCUMWO',
	movedDown: '_3elhneKN',
	collapsed: '_2KSQKL9A',
	dragIcon: 'tH19HhIJ',
	primary: '_1LxKutxg',
	leading: '_3hwazrOQ',
	trailing: '_8vdXMsni',
	' _key': 'certwise-theme/dojo/list-item'
};

export default css;
